var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","clsas":"col-sm-12"}},[(_vm.isLoading)?_c('div',{attrs:{"id":"loading-spinner"}},[_c('clip-loader',{attrs:{"loading":_vm.isLoading,"color":_vm.color,"size":_vm.size}})],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }